import { RootState } from "@/store";
import { EmployeeState } from "@/types/employeeState";
import { lightenHex } from "@/utils/getBrandings";
import { Button } from "@WealthierAI/core";
import { AlertCircle } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const VISIBLE_STATES: EmployeeState[] = [
  EmployeeState.Accepted,
  EmployeeState.KYCDataCompleted,
  EmployeeState.KYCDataPending,
];

interface AdditionalDataAlertProps {
  onOpenIframe: () => void;
}

const AdditionalDataAlert: React.FC<AdditionalDataAlertProps> = ({
  onOpenIframe,
}) => {
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.user);

  const isAuthenticated = !!user.id;
  const isVisible =
    isAuthenticated &&
    VISIBLE_STATES.includes(user.enrolledStatus as EmployeeState);

  if (!isVisible) return null;

  return (
    <div
      style={{
        background: window.partner?.colors?.primary
          ? lightenHex(window.partner.colors.primary, 0.95)
          : "var(--sootchy-bg-75)",
        borderBottomColor: window.partner?.colors?.primary
          ? lightenHex(window.partner.colors.primary, 0.6)
          : "var(--sootchy-brand-accent)",
      }}
      className="w-full border-b-2 shadow-lg"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="flex-shrink-0 mt-1">
              <AlertCircle
                style={{ color: window.partner?.colors?.primary }}
                className="w-6 h-6 animate-pulse"
              />
            </div>
            <div className="flex-1">
              <h3
                style={{ color: window.partner?.colors?.primary }}
                className="text-lg font-bold mb-1"
              >
                {t("additional_data_collection.action_required")}
              </h3>
              <p
                style={{ color: window.partner?.colors?.primary }}
                className="text-sm opacity-80"
              >
                {t("additional_data_collection.description")}
              </p>
            </div>
          </div>
          <Button
            onClick={onOpenIframe}
            className="!bg-brand-default flex-shrink-0 hover:opacity-90 text-white font-semibold px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105 active:scale-95 whitespace-nowrap"
            aria-label="Open data entry form"
          >
            {t("additional_data_collection.button_text")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdditionalDataAlert;
